/* @flow */

import AccurateTimestamp from '../../helpers/dateTime/AccurateTimestamp';
import { MILLISECONDS_PER_SECOND } from '../../helpers/dateTime/Format';
import { isTabHidden } from '../../helpers/ui/browser';

// Elapsed time is checked every 2 seconds (in ms)
const DEFAULT_INTERVAL = 2_000;

// Sleep time is detected when time jumped by more than 5 seconds (in ms)
const DEFAULT_THRESHOLD = 5_000;

export default class SleepDetector {
  checkInterval: number;
  intervalId: IntervalID | null;
  isTabHidden: boolean;
  lastCheckTimestamp: number;
  onSleepDetected: (sleepDurationInSeconds: number) => void;
  sleepThreshold: number;

  constructor(onSleepDetected: (sleepDurationInSeconds: number) => void, checkInterval: number = DEFAULT_INTERVAL, sleepThreshold: number = DEFAULT_THRESHOLD) {
    this.checkInterval = checkInterval;
    this.intervalId = null;
    this.isTabHidden = isTabHidden();
    this.lastCheckTimestamp = 0;
    this.onSleepDetected = onSleepDetected;
    this.sleepThreshold = sleepThreshold;

    this.start();
  }

  start = () => {
    this.stop();
    this.lastCheckTimestamp = AccurateTimestamp.now();

    if (document !== undefined) {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    this.intervalId = setInterval(this.check, this.checkInterval);
  };

  stop = () => {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    if (document !== undefined) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  };

  handleVisibilityChange = () => {
    this.isTabHidden = isTabHidden();

    // Reset timestamp when returning to the tab so tab-switching doesn't trigger a wake delta
    if (!this.isTabHidden) {
      this.lastCheckTimestamp = AccurateTimestamp.now();
    }
  };

  check = () => {
    const now = AccurateTimestamp.now();
    const delta = now - this.lastCheckTimestamp;

    // Only report sleep if the tab was visible during the gap (prevents tab-switch false positives)
    if (!this.isTabHidden && delta > this.sleepThreshold) {
      const sleepInSeconds = Math.round(delta / MILLISECONDS_PER_SECOND);
      this.onSleepDetected(sleepInSeconds);
    }

    this.lastCheckTimestamp = now;
  };
}
